import { Box, BoxProps, CircularProgress } from "@mui/material";

export interface CircularLoaderProps extends BoxProps {
  loading: boolean;
  children: React.ReactNode;
}

function CircularLoader(props: CircularLoaderProps) {
  const { loading, children, sx } = props;

  return (
    <Box sx={{ position: "relative", ...sx }}>
      {children}
      {loading && (
        <Box
          sx={{
            height: 24,
            left: "50%",
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  );
}

export default CircularLoader;
